// Source: https://unicode.org/cldr/trac/browser/trunk/common/main/pt_PT.xml?rev=14409#L491
module["exports"] = {
  wide: [
    "Segunda",
    "Terça",
    "Quarta",
    "Quinta",
    "Sexta",
    "Sábado",
    "Domingo"
  ],
  abbr: [
    "Seg",
    "Ter",
    "Qua",
    "Qui",
    "Sex",
    "Sáb",
    "Dom"
  ]
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/pt_PT/date/weekday.js
// module id = 3455
// module chunks = 1610